export default __webpack_public_path__ + "locales/sq-AL/ConvertDialog.json?hash=b09899441405801b35212cbaf2876246";